import Button from "components/button/Button";
import { apiResendMailClinic } from "helpers/api/clinic";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ROUTE } from "routes/route";
import { showToastError, showToastSuccess } from "utils";

const CompleteSignUp = ({ values }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleResend = async () => {
    apiResendMailClinic({
      email: values?.email,
    })
      .then((res) => showToastSuccess("messages.MSG-USP085"))
      .catch((error) => showToastError(error?.message));
  };
  return (
    <div className="clinic-container">
      <div className="clinic-layout mt-4">
        <div
          className="clinic-col"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className="clinic-title">{t("signUp.complete.title")}</div>
          <div className="clinic-success-msg">
            {t("signUp.complete.content")}
          </div>
          <div className="clinic-success-email-title">
            {t("signUp.complete.email")}
          </div>
          <div className="clinic-success-email">{values?.email}</div>
          <Button
            text={"ログインする"}
            className="clinic-login-button"
            onClick={() => history.push(ROUTE.PUBLIC.LOGIN)}
          />
          <div className="clinic-success-link" onClick={handleResend}>
            {t("signUp.complete.btnLogin")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompleteSignUp;
